import { createVehicles, updateVehicles } from 'api/vehicles';
import { VehicleContractTypes } from 'enums/types';
import {
  debounceChecklists,
  debounceDriver,
  debouncePartner,
  debounceProject,
  debounceRegional,
  debounceVehicleType,
} from 'utils/debounces';

import type { FormType } from '..';

export const vehicleForm: FormType = {
  createFn: createVehicles,
  updateFn: updateVehicles,
  cancelText: 'Cancelar',
  submitText: 'Salvar Veículo',
  disableText: 'Desativar Veículo',
  enableText: 'Reativar Veículo',
  successText: 'Veículo salvo com sucesso!',
  fields: [
    [
      {
        name: 'contract',
        type: 'radio',
        required: true,
        props: {
          label: 'Proprietário:',
          options: Object.values(VehicleContractTypes).map(
            (type) => ({ label: type, value: type })),
        },
      },
    ],
    [
      {
        name: 'partner',
        type: 'select',
        required: true,
        hidden: ['contract', '!==', VehicleContractTypes.Partner],
        props: {
          placeholder: 'Buscar',
          label: 'Parceiro',
          loadOptions: debouncePartner,
        },
      },
    ],
    [
      {
        name: 'rentedAt',
        type: 'date',
        required: true,
        hidden: ['contract', '!==', VehicleContractTypes.Rented],
        props: {
          placeholder: '01/01/2000',
          label: 'Data do Aluguel',
        },
      },
      {
        name: 'rentDueAt',
        type: 'date',
        required: false,
        hidden: ['contract', '!==', VehicleContractTypes.Rented],
        props: {
          placeholder: '01/01/2000',
          label: 'Data final do Aluguel',
        },
      },
    ],
    [
      {
        name: 'project',
        type: 'select',
        required: false,
        props: {
          placeholder: 'Buscar',
          label: 'Projeto',
          loadOptions: debounceProject,
        },
      },
      {
        name: 'regional',
        type: 'select',
        required: false,
        props: {
          placeholder: 'Buscar',
          label: 'Regional',
          loadOptions: debounceRegional,
        },
      }],
    [],
    [
      {
        name: 'licensePlate',
        type: 'text',
        required: true,
        mask: 'maskLicensePlate',
        props: {
          placeholder: 'HNF-0918',
          label: 'Placa',
        },
      },
      {
        name: 'manufacturer',
        type: 'text',
        required: true,
        props: {
          placeholder: 'Mercedes',
          label: 'Fabricante',
        },
      },
    ],
    [
      {
        name: 'model',
        type: 'text',
        required: true,
        props: {
          placeholder: 'Strada',
          label: 'Modelo',
        },
      },
      {
        name: 'color',
        type: 'text',
        required: true,
        props: {
          placeholder: 'Prata',
          label: 'Cor',
        },
      },
    ],
    [
      {
        name: 'vehicleType',
        type: 'select',
        required: true,
        props: {
          placeholder: 'Buscar',
          label: 'Tipo',
          loadOptions: debounceVehicleType,
        },
      },
    ],
    [
      {
        name: 'manufactureYear',
        type: 'text',
        required: true,
        rules: {
          maxLength: 4,
          minLength: 4,
        },
        props: {
          placeholder: '2020',
          label: 'Ano de Fabricação',
        },
      },
      {
        name: 'modelYear',
        type: 'text',
        required: true,
        rules: {
          maxLength: 4,
          minLength: 4,
        },
        props: {
          placeholder: '2020',
          label: 'Ano do Modelo',
        },
      },
    ],
    [
      {
        name: 'reindeer',
        type: 'text',
        required: true,
        props: {
          placeholder: '00000000-0',
          label: 'Renavam',
        },
      },
      {
        name: 'chassis',
        type: 'text',
        required: true,
        props: {
          placeholder: '9BW ZZZ3777 VT 004251',
          label: 'Chassi',
        },
      },
    ],
    [
      {
        name: 'inclusionDate',
        type: 'date',
        required: true,
        props: {
          placeholder: '01/01/2000',
          label: 'Data de inclusão na Frota',
        },
      },
      {
        name: 'inclusionKm',
        type: 'text',
        required: true,
        mask: 'maskKm',
        props: {
          placeholder: '7.000',
          label: 'Km de entrada na Frota',
        },
      },
    ],
    [
      {
        name: 'documentUrl',
        type: 'image',
        required: false,
        props: {
          label: 'Foto do Documento',
        },
      },
    ],
    [],
    [
      {
        name: 'vehicleUrls',
        isMultiple: true,
        type: 'image',
        required: false,
        props: {
          label: 'Fotos do Veículo',
        },
      },
    ],
    [],
    [
      {
        name: 'drivers',
        isMultiple: true,
        type: 'select',
        required: true,
        props: {
          placeholder: 'Buscar',
          label: 'Condutor',
          loadOptions: debounceDriver,
        },
      },
    ],
    [],
    [
      {
        name: 'checklists',
        isMultiple: true,
        type: 'select',
        required: false,
        props: {
          placeholder: 'Buscar',
          label: 'Checklists do veículo',
          loadOptions: debounceChecklists,
        },
      },
    ],
  ],
};
